


import { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import Spinner from "../spinner/Spinner";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import DefaultAvatar from "../../components/utils/DefaultAvatar";
import { handleError } from "../../components/utils/AuthenticationCheck";
import CurrencyFormatter from "../../components/utils/CurrencyFormatter";

const DeliveryPriceDetails = () => {
    const [deliveryDetails, setDeliveryDetails] = useState({});
    const [loading, setLoading] = useState(false);
    // const [currentPage, setCurrentPage] = useState(1);
    // const itemsPerPage = 1;

    const navigate = useNavigate();
    const location = useLocation();
    const deliveryPrice = location.state?.deliveryPrice;
    // console.log("delivery", deliveryPrice);


    useEffect(() => {
        if (deliveryPrice) {
            // console.log("Setting delivery details from location", deliveryPrice);
            setDeliveryDetails(deliveryPrice);
        }
    }, [deliveryPrice]);




    return (
        <MainLayouts>
            <div className="relative sm:rounded-lg py-6 w-full">
                <section
                    className="w-full pr-[3%] pt-3 my-3"
                    style={{ backgroundColor: "#F7F7F7" }}
                >
                    <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                        <ol className="list-none p-0 inline-flex mb-2">
                            <li className="flex items-center">
                                <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                                    Location Delivery
                                </p>
                                <ChevronRightIcon />
                            </li>
                            <li className="flex items-center">
                                <p className="text-orange1">Details</p>
                            </li>
                        </ol>
                    </nav>
                </section>

                {loading ? (
                    <Spinner loading={loading} />
                ) : (
                    <section className="text-gray-600 body-font">
                        <div className="container">
                            <div className="flex justify-end mb-3">
                                <Link
                                    to="/admin/delivery/location"
                                    className="w-full sm:w-auto text-dGrey3 bg-darkGreen3 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                >
                                    <span className="flex justify-center sm:justify-start mx-2">
                                        <ArrowLeftSquare className="mr-2" />
                                        Back
                                    </span>
                                </Link>
                            </div>

                            <div className="flex flex-wrap -m-2">
                                <div className="px-1 w-full lg:w-4/5 mt-2 mb-4">
                                    <div className="flex items-center border-dash border p-1 rounded-lg border-l-4">
                                        <section className="body-font w-full">
                                            <div className="container px-2">
                                                <div className="w-full flex flex-wrap">
                                                    <div className="w-full px-4">

                                                        <h2 className="text-sm title-font mt-2">
                                                            <strong>State</strong> :  {deliveryDetails.state
                                                                ? deliveryDetails.state
                                                                : "Not Available"}
                                                        </h2>
                                                        <h1 className="hidden md:block text-dash text-3xl title-font font-medium mb-1">
                                                            <strong>City</strong> :  {deliveryDetails.city
                                                                ? deliveryDetails.city
                                                                : "Not Available"}
                                                        </h1>

                                                        <span className="bg-dash text-dGrey3 text-xs font-medium me-2 px-3 py-1 rounded-full dark:bg-blue-900 dark:text-blue-300">
                                                            <strong>Location</strong> : {deliveryDetails.location
                                                                ? deliveryDetails.location.toUpperCase()
                                                                : "Not Available"}
                                                        </span>
                                                        <p className="leading-relaxed mb-4 mt-3">
                                                            <strong>LGA</strong> :{deliveryDetails.lga
                                                                ? deliveryDetails.lga
                                                                : "Not Available"}
                                                        </p>
                                                        <p className="leading-relaxed mb-4 mt-3">
                                                            <strong>Price</strong> : {deliveryDetails.amount
                                                                ? CurrencyFormatter(deliveryDetails.amount)
                                                                : "CurrencyFormatter(0.00)"}
                                                        </p>
                                                        <div className="flex border-t border-gray-200 py-2">
                                                            <span className="text-gray-500">LCDA</span>
                                                            <span className="ml-auto text-dash">
                                                                {deliveryDetails.lcda
                                                                    ? deliveryDetails.lcda.toUpperCase()
                                                                    : "Not Available"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </div>
        </MainLayouts>
    );
};

export default DeliveryPriceDetails;
